import { render } from "./CustomSection.vue?vue&type=template&id=4863f3c2"
const script = {}

import "./CustomSection.vue?vue&type=style&index=0&id=4863f3c2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__